import EditAlphaTabs from './edit-alpha-tabs'

export default EditAlphaTabs
